import React from "react";

// Sprint 9 — Skeleton-Loader für Anliegen-Co-Creator Ergebnis-Bereich.
// Wird ~9-10 Sek angezeigt während LLM-Call läuft, sodass User sofort
// visuelles Feedback bekommt statt nur einen kleinen Spinner.

function SkeletonBlock({ className = "" }) {
  return <div className={`animate-pulse bg-stone-200 rounded ${className}`} />;
}

export default function AnliegenSkeleton() {
  return (
    <div
      data-testid="anliegen-skeleton"
      className="space-y-6"
      aria-busy="true"
      aria-live="polite"
    >
      {/* Verdacht-Card-Skeleton */}
      <section className="bg-white border border-stone-200 rounded-lg p-6 border-t-4 border-t-stone-300">
        <SkeletonBlock className="h-3 w-24 mb-3" />
        <SkeletonBlock className="h-6 w-3/4 mb-2" />
        <SkeletonBlock className="h-4 w-full mt-3" />
        <SkeletonBlock className="h-4 w-5/6 mt-2" />
      </section>

      {/* Türsteher-Insight-Skeleton */}
      <section className="bg-blue-50 border-l-4 border-blue-200 rounded p-5">
        <SkeletonBlock className="h-3 w-32 mb-3 bg-blue-100" />
        <SkeletonBlock className="h-4 w-full mt-1 bg-blue-100" />
        <SkeletonBlock className="h-4 w-4/5 mt-2 bg-blue-100" />
      </section>

      {/* Flexpfad-Block-Skeleton */}
      <section className="bg-white border border-stone-200 rounded-lg p-6 border-l-4 border-l-green-200">
        <div className="flex items-center justify-between mb-4">
          <SkeletonBlock className="h-3 w-32" />
          <SkeletonBlock className="h-3 w-20" />
        </div>
        <SkeletonBlock className="h-4 w-full mb-2" />
        <SkeletonBlock className="h-4 w-full mb-2" />
        <SkeletonBlock className="h-4 w-full mb-2" />
        <SkeletonBlock className="h-4 w-11/12 mb-2" />
        <SkeletonBlock className="h-4 w-10/12 mb-2" />
        <SkeletonBlock className="h-4 w-5/6 mb-4" />
        <div className="flex items-center justify-between mt-4">
          <SkeletonBlock className="h-8 w-24" />
          <SkeletonBlock className="h-3 w-20" />
        </div>
      </section>
    </div>
  );
}
